// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__28T9U","question":"Question_question__2JTvv","description":"Question_description__1kyo0"};